import Hero from './components/Hero';
import CTASection from './components/CTASection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticleCards from './components/ArticleCards';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import SchemaOrg from '@/components/SchemaOrg';

interface SchemaOrgData {
  '@context': string;
  '@type': string;
  [key: string]: unknown;
}

const SITE_URL = 'https://yoybuy.beauty';

const homepageSchema: SchemaOrgData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'YOYBUY Spreadsheet — ваш гид по шоппингу из Китая',
  description: 'YOYBUY Spreadsheet: полное руководство по шоппингу из Китая через spreadsheet-агентов. Сравнение YOYBUY, Kakobuy и Superbuy. Умный шоппинг, низкие комиссии, быстрая доставка в Россию.',
  url: SITE_URL + '/',
  inLanguage: 'ru',
  publisher: {
    '@type': 'Organization',
    name: 'YOYBUY Beauty',
    url: SITE_URL + '/',
  },
};

export default function Home() {
  return (
    <>
      <SchemaOrg schema={homepageSchema} />
      <main>
        <Hero />
        <CTASection />
        <CategoryGrid />
        <AboutSection />
        <ArticleCards />
        <Testimonials />
        <Footer />
      </main>
    </>
  );
}